import { render, staticRenderFns } from "./VehicleNewPolicy.vue?vue&type=template&id=51694a5e&scoped=true&"
import script from "./VehicleNewPolicy.vue?vue&type=script&lang=js&"
export * from "./VehicleNewPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51694a5e",
  null
  
)

export default component.exports